export default {
    attachments: '/attachments',
    images: '/attachments/images',
};
